import { _, commonLocaleConverter, LocalizationConfig } from '@any2any/shared';
import deApp from 'src/app/data/i18n/de.json';
import enApp from 'src/app/data/i18n/en.json';
import frApp from 'src/app/data/i18n/fr.json';

export const appLocalization = new LocalizationConfig({
  en: {
    data: [enApp],
    label: _('app.language_names.english')
  },
  de: {
    data: [deApp],
    label: _('app.language_names.german')
  },
  // fr: {
  //   data: [frApp],
  //   label: _('app.language_names.french')
  // }
}, 'en', {
  reflectedLocaleConverter: commonLocaleConverter
});
